define.alias("ember-power-select/components/power-select/power-select-group", "settings/components/power-select/power-select-group");